var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 135.999,
    height: 135.999,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 3598.32 3598.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .fil2{fill:#8c8c8c;fill-rule:nonzero}\n    "))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2579653805520"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M-.01 0h3598.33v3598.33H-.01z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1421394342400"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343434",
      fillRule: "nonzero"
    },
    d: "m1821.65 141.22-22.49 76.37V2433.6l22.49 22.43L2850.28 1848z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M1821.65 141.22 792.99 1848l1028.66 608.03V1380.44z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c3c3b",
      fillRule: "nonzero"
    },
    d: "m1821.65 2650.78-12.67 15.46v789.37l12.67 37L2850.9 2043.07z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M1821.65 3492.61v-841.83L792.99 2043.07z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414",
      fillRule: "nonzero"
    },
    d: "M1821.65 2456.03 2850.28 1848l-1028.63-467.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393939",
      fillRule: "nonzero"
    },
    d: "m792.99 1848 1028.66 608.03V1380.44z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.ad50c5e3f0ffa6176492ddeed3692fd6.svg";
export { ForwardRef as ReactComponent };